import {cityFull} from "../types/entities/city";
import {provinceFull} from "../types/entities/users";

export default function (formattedAddress: string) {
  if (!formattedAddress) return {};
  const addressParts = formattedAddress.split(',').map((part) => part.trim());
  const [address, subDisctrict, district, cityRegency, province, postalCode, country] = addressParts;

  const cityRegencyCode = Object.keys(cityFull).find(
    (code) => cityFull[code].toUpperCase() === cityRegency.toUpperCase()
  ) ?? '';

  const provinceCode = Object.keys(provinceFull).find(
    (code) => provinceFull[code].toUpperCase() === province.toUpperCase()
  ) ?? '';

  return {
    address,
    subDisctrict,
    district,
    cityRegency: cityRegencyCode ? cityRegencyCode+'' : '',
    province: provinceCode ? provinceCode+'' : '',
    postalCode,
    country,
  };
}
